import md5 from 'md5';
import http from './http';
import pkg from '../../../package.json';

const LBS_API = {
  // fat: 'https://fat-hello-location-based-services.hellobike.com/api',
  // uat: 'https://uat-hello-location-based-services.hellobike.cn/api',
  // pre: 'https://pre-hello-location-based-services.hellobike.cn/api',
  pro: 'https://hello-location-based-services.hellobike.com/api',
};

export function LBSRequest({
  appKey,
  secretKey,
  action,
  arg0,
  method,
}) {
  const now = Date.now();
  let strArg0 = arg0;

  try {
    strArg0 = JSON.stringify(arg0);
  } catch (e) {
    // empty
  }

  const params = {
    appName: 'appPlarformH5',
    version: pkg.version,
    releaseVersion: pkg.version,
    from: 'h5',
    systemCode: 63,
    action,
    arg0: strArg0,
    arg1: {
      appKey,
      // 计算签名
      signature: md5(`${strArg0 || appKey}${now}${secretKey}`),
      src: 'SMALL_PROGRAM',
      timestamp: now,
    },
    method,
  };

  return http.post(`${LBS_API.pro}?${action}`, params);
}

export const regeoCodingSearch = ({
  appKey,
  secretKey,
  lng, lat,
}) => LBSRequest({
  appKey,
  secretKey,
  action: 'hello.lbs.code.regeo',
  arg0: {
    locations: [{ lat, lng }],
    extensions: 'all',
    radius: 100,
    isAmapStandard: 1,
  },
  method: 'reGeoCodingSearch',
});
